export class MapLink {
  id: string = null;
  way1: string = null;
  way2: string = null;
  from: string = null;
  to: string = null;
  label: string = null;
  isDisable = false;
  data: any = null;
  thematicClassification = 0;
  rank = 0;
  score = 0.0;
  is2Ways = false;
  labelsWay1: Set<string> = new Set<string>();
  labelsWay2: Set<string> = new Set<string>();
  curvature = 0.0;

  constructor(element: MapLink) {
    if (element) {
      this.id = element.id;
      this.way1 = element.way1;
      this.way2 = element.way2;
      this.from = element.from;
      this.to = element.to;
      this.label = element.label;
      this.isDisable = element.isDisable;
      this.data = Object.assign({}, element.data);
      this.thematicClassification = element.thematicClassification;
      this.rank = element.rank;
      this.score = element.score;
      this.is2Ways = element.is2Ways;
      this.labelsWay1 = new Set<string>(element.labelsWay1);
      this.labelsWay2 = new Set<string>(element.labelsWay2);
      this.curvature = element.curvature;
    }
  }
}
